import React, { useEffect, useState } from "react";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Button,
  Chip,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  RadioGroup,
  Select,
  Typography,
} from "@mui/material";
import {
  myPagesFortnoxGetLabels,
  myPagesFortnoxGetStatus,
  myPagesFortnoxSendToClient,
} from "API/myPages";
import { Radio } from "@mui/material";
import {
  FORTNOX_STATUS,
  getFortnoxStatusTranslation,
  getFortnoxStatusColor,
} from "utils/options/FORTNOX_STATUS";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  borderRadius: "4px",
  boxShadow: 24,
  p: 6,
};

export default function MyPageFortnox({ client }) {
  const [status, setStatus] = useState(null);
  const [labels, setLabels] = useState([]);
  const [importStatus, setImportStatus] = useState(
    client?.FortnoxImportAll ?? ""
  );
  const [modalOpen, setModalOpen] = useState(false);

  const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => {
    setModalOpen(false);
    setImportStatus(client?.FortnoxImportAll ?? "");
    asyncGetLabelsByClientId(client.Id);
  };

  const asyncUpdateImportStatus = async () => {
    if (client) {
      setImportStatus(client?.FortnoxImportAll ?? "");
    }
  };

  const asyncHandleSendToClient = async () => {
    const res = await myPagesFortnoxSendToClient();

    if (res.status === 200) {
      const url = res.data;
      window.location.href = url;
    }
  };

  const asyncFetchStatus = async () => {
    const res = await myPagesFortnoxGetStatus();

    if (res.status === 200) {
      setStatus(res.data);
    }
  };

  const asyncGetLabelsByClientId = async () => {
    var res = await myPagesFortnoxGetLabels();

    if (res.status === 200) {
      setLabels(res.data);
    }
  };

  useEffect(() => {
    asyncFetchStatus();
    asyncGetLabelsByClientId();
    asyncUpdateImportStatus();
  }, [client]);

  if (status == null || status === FORTNOX_STATUS.UNSENT) return null;

  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
        gap: "5px",
        padding: "32px",
        minHeight: "200px",
      }}
    >
      {client && (
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingBottom: "1rem",
            }}
          >
            <Typography variant="subtitle2">Fortnox</Typography>
            <Chip
              label={getFortnoxStatusTranslation(status)}
              color={getFortnoxStatusColor(status)}
              sx={{ minWidth: "6rem" }}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem",
              }}
            >
              <LoadingButton
                variant="contained"
                disabled={status === null || status === FORTNOX_STATUS.VERIFIED}
                onClick={() => asyncHandleSendToClient()}
                sx={{ width: "100%", gap: "1rem" }}
              >
                Aktivera integration
              </LoadingButton>
              <Button
                variant="contained"
                onClick={handleModalOpen}
                sx={{ width: "100%" }}
                disabled={status !== FORTNOX_STATUS.VERIFIED}
              >
                Visa etiketter
              </Button>
            </div>
          </div>
          <Modal
            open={modalOpen}
            onClose={handleModalClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={modalStyle}>
              <Typography
                variant="subtitle2"
                sx={{ marginBottom: "1rem", textAlign: "center" }}
              >
                Fortnox - Etiketter (Visningsvy)
              </Typography>

              {status === FORTNOX_STATUS.VERIFIED ? (
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel>Import</InputLabel>
                  <Select
                    sx={{ marginBottom: "1rem" }}
                    label="Import"
                    value={importStatus}
                    disabled={true}
                  >
                    <MenuItem value={true}>Importera alla</MenuItem>;
                    <MenuItem value={false}>Exkludera alla</MenuItem>;
                  </Select>
                  <div
                    style={{
                      display: "grid",
                      gridAutoRows: "1fr",
                      marginBottom: "1rem",
                    }}
                  >
                    {labels.map((label, index) => {
                      return (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: "4rem",
                            borderBottom:
                              index === labels.length - 1
                                ? "none"
                                : "2px solid #f6f3f4",
                            padding: "0.5rem",
                          }}
                        >
                          <FormLabel id={label.id}>
                            {label.Description}
                          </FormLabel>
                          <RadioGroup
                            id={label.Id}
                            name={label.Description}
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                            value={
                              label.Excluded != null
                                ? label.Excluded.toString()
                                : ""
                            }
                          >
                            <FormControlLabel
                              value="false"
                              control={<Radio />}
                              label="Importera"
                              disabled={true}
                            />
                            <FormControlLabel
                              value="true"
                              control={<Radio />}
                              label="Exkludera"
                              disabled={true}
                            />
                          </RadioGroup>
                        </div>
                      );
                    })}
                  </div>
                  <Typography
                    variant="subtitle1"
                    sx={{ marginTop: "1rem", textAlign: "center" }}
                  >
                    Kontakta Swesum om du vill att någon etikett ska ändras.
                  </Typography>
                  <Button
                    sx={{ marginTop: "1rem" }}
                    variant="outlined"
                    color="error"
                    onClick={handleModalClose}
                  >
                    Stäng
                  </Button>
                </FormControl>
              ) : (
                ""
              )}
            </Box>
          </Modal>
        </div>
      )}
    </Paper>
  );
}
